import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledAiSubmenuComponent } from "./ai-submenu-component.scss";
import { USE_CASES, CAPABILITY_SECTIONS } from "./ai-submenu-constants";
const AiSubmenuComponent = ({ translate })=>{
    return /*#__PURE__*/ _jsxs(StyledAiSubmenuComponent, {
        className: "ai-submenu-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "use-cases-section submenu-stagger-item",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "ai-submenu-main-title",
                        children: translate("header.tabs.aiPlatform.left.title")
                    }),
                    USE_CASES.map(({ iconUrl, titleKey, descKey, link })=>/*#__PURE__*/ _jsxs("a", {
                            className: "use-case-item submenu-stagger-item",
                            href: link,
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ _jsx("img", {
                                    className: "use-case-icon",
                                    src: iconUrl,
                                    alt: ""
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "use-case-text",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "use-case-title",
                                            children: translate(titleKey)
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "use-case-desc",
                                            children: translate(descKey)
                                        })
                                    ]
                                })
                            ]
                        }, link))
                ]
            }),
            CAPABILITY_SECTIONS.map(({ groupKey, items })=>/*#__PURE__*/ _jsxs("div", {
                    className: "capabilities-section submenu-stagger-item",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "section-header",
                            children: translate(groupKey)
                        }),
                        items.map(({ labelKey, link })=>/*#__PURE__*/ _jsx("a", {
                                className: "capability-item",
                                href: link,
                                rel: "noreferrer",
                                children: /*#__PURE__*/ _jsx("span", {
                                    className: "capability-label",
                                    children: translate(labelKey)
                                })
                            }, link))
                    ]
                }, groupKey))
        ]
    });
};
export default withGenericConfig(AiSubmenuComponent);
